import React, { useEffect, useState } from "react";
import * as apiMethods from '../res/apiMethods.js';
import axios from "axios";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import Button from "@mui/material/Button";
/* import history from "../services/history.service.js"; */
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import Sidebar from "../components/Sidebar";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
    const [loggedIn, setLoggedIn] = useState(null);
    const [username, setUsername] = useState('');

    useEffect(() => {
        const token = window.sessionStorage.getItem('localToken');
        const storedUser = window.sessionStorage.getItem('username');
        if (token && storedUser) {
            document.title = "Perfil";
            setUsername(storedUser);
            setLoggedIn(true);
        } else {
            document.title = "Login";
            setLoggedIn(false);
        }
    }, []);

    const validate = (values) => {
        const errors = {};
        if (!values.username) errors.username = 'Requerido';
        if (!values.password) errors.password = 'Requerido';
        if (values.password2 && values.password !== values.password2) errors.password2 = 'No coinciden';
        return errors;
    };

    const formik = useFormik({
        initialValues: { username: '', password: '', password2: '' },
        validate,
        onSubmit: async (values, { setSubmitting }) => {
            Swal.fire({ title: "Cargando...", allowOutsideClick: false });
            Swal.showLoading();
            try {
                const response = await axios.post(apiMethods.LOGIN, { username: values.username, password: values.password });
                if (response.data && response.data.code === 0) {
                    const { token, userData } = response.data;
                    window.sessionStorage.setItem('localToken', token);
                    window.sessionStorage.setItem('username', userData.username);
                    window.sessionStorage.setItem('loggedIn', "true");
                    Swal.close();
                    window.location.href = userData.urlDestino;
                } else {
                    Swal.close();
                    toast.error((response.data && response.data.message) || "Credenciales incorrectas");
                }
            } catch (error) {
                Swal.close();
                toast.error("Error de conexión con el servidor");
            } finally {
                setSubmitting(false);
            }
        }
    });

    const handleUpdatePassword = async () => {
        const { password, password2 } = formik.values;
        if (!password || !password2) return toast.error("Complete ambos campos de contraseña");
        if (password !== password2) return toast.error("Las contraseñas no coinciden");
        try {
            const token = window.sessionStorage.getItem('localToken');
            const res = await axios.patch(apiMethods.UPDATE_PASSWORD,
                { password },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.data && res.data.code === 0) {
                toast.success("Contraseña actualizada exitosamente");
                formik.setFieldValue('password', '');
                formik.setFieldValue('password2', '');
            } else {
                toast.error((res.data && res.data.message) || "Error al actualizar");
            }
        } catch (e) {
            toast.error("No se pudo actualizar la contraseña");
        }
    };

    const handleLogout = () => {
        window.sessionStorage.removeItem('localToken');
        window.sessionStorage.removeItem('username');
        window.sessionStorage.removeItem('loggedIn');
        setLoggedIn(false);
        window.location.href('/login');
    };

    if (loggedIn === null) return null;

    return (
        <>
            <ToastContainer />
            {loggedIn ? (
                <div style={{ display: "grid", gridTemplateColumns: "15% 85%" }}>
                    <Sidebar />
                    <div className="card" style={{ width: "100%", padding: 24 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>Detalle Usuario: <span style={{ color: '#333' }}>{username}</span></h2>
                            <Button variant="outlined" color="secondary" onClick={handleLogout}>Cerrar sesión</Button>
                        </div>
                        <hr />
                        <h4>Cambiar contraseña</h4>
                        <div style={{ display: "flex", gap: 16, alignItems: "center", marginTop: 8 }}>
                            <TextField
                                id="password"
                                name="password"
                                label="Nueva Contraseña"
                                type="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                autoComplete="new-password"
                            />
                            <TextField
                                id="password2"
                                name="password2"
                                label="Confirmar Contraseña"
                                type="password"
                                value={formik.values.password2}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.password2 && Boolean(formik.errors.password2)}
                                helperText={formik.touched.password2 && formik.errors.password2}
                                autoComplete="new-password"
                            />
                            <Button variant="contained" color="primary" onClick={handleUpdatePassword}>Cambiar</Button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="center">
                   <div className="cardSquare" style={{ border: 'none !important' }}>
                        <form onSubmit={formik.handleSubmit} noValidate>
                            <div className="loginHead" style={{ textAlign: "center" }}>
                                <img src={require('../res/logo-mobilia.jpg')} height="170" alt="Logo" />
                            </div>
                            <TextField
                                fullWidth
                                id="username"
                                name="username"
                                label="Usuario"
                                margin="normal"
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.username && Boolean(formik.errors.username)}
                                helperText={formik.touched.username && formik.errors.username}
                                autoFocus
                                inputProps={{ 'aria-label': 'usuario' }}
                            />
                            <TextField
                                fullWidth
                                id="passwordLogin"
                                name="password"
                                label="Contraseña"
                                type="password"
                                margin="normal"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                inputProps={{ 'aria-label': 'contraseña' }}
                            />
                            <div style={{ textAlign: "center", marginTop: "2rem" }}>
                                <Button type="submit" variant="contained" color="primary" disabled={formik.isSubmitting}>
                                    {formik.isSubmitting ? 'Ingresando...' : 'Ingresar'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default Login;